<template>
  <div class="calendar" v-if="$store.getters.IS_LOGGED_IN">
    <div class="mb-1">
      <div class="tool-bar mb-1">
        <div>
          <el-dropdown
            size="small"
            split-button type="warning"
            @command="handleCommand" trigger="click">
            Xin chào, {{ $store.getters.USER.full_name }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">
                Đăng xuất
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <calendar is-expanded
                ref="calendar"
                @update:from-page="changeMonth"
                :attributes="attributes"
                :available-dates='{ start: new Date(), end: null }'
                @dayclick="onDayClick"/>
    </div>

    <el-tabs v-model="activeName" style="width: 100%;">
      <el-tab-pane label="Đã chọn" name="Đã chọn" v-if="days.length > 0">
        <div style="margin-bottom: 15px;" v-if="btnCreate || idsCancel.length > 0">
          <el-button
            type="success"
            icon="el-icon-circle-plus-outline"
            plain
            :disabled="btnHandling"
            v-if="btnCreate"
            @click="save"
            size="mini">
            Đăng ký
          </el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            plain
            :disabled="btnHandling"
            v-if="idsCancel.length > 0"
            @click="cancel"
            size="mini">
            Hủy suất
          </el-button>
        </div>
        <div>
          <el-checkbox @change="allBreakfast" v-model="isAllBreakfast">
            Tất cả bữa sáng
          </el-checkbox>
          <el-checkbox @change="allLunch" v-model="isAllLunch">
            Tất cả bữa trưa
          </el-checkbox>
          <el-checkbox @change="allAfternoonSnack" v-model="isAllAffternoonSnack">
            Tất cả bữa chiều
          </el-checkbox>
          <el-checkbox @change="allDinner" v-model="isAllDinner">
            Tất cả bữa tối
          </el-checkbox>
        </div>

        <div class="meal">
          <div v-for="day in days" :key="'day-selected'+day.id">
            <el-divider content-position="left">Ngày {{ dateToStringFormat(day.date) }}</el-divider>
            <div style="text-align: center;">
              <el-checkbox-group v-model="day.mealSelected" size="small">
                <el-checkbox-button
                  v-for="type in day.data"
                  :label="type.id"
                  :class="{'exist-meal': type.hasMealSet, 'past-meal': type.is_past}"
                  style="position: relative;"
                  :disabled="type.hasMealSet || type.is_past"
                  :key="'meal-'+type.id">
                  <label :for="'checkbox'+type.id"
                         v-if="!type.is_past && type.hasMealSet"
                         style="position: absolute; top: -18px; left: -1px;">
                    <input
                      type="checkbox"
                      v-model="type.checkbox"
                      @change="cancelSelected(type.mealSetId)">
                  </label>
                  <el-tooltip
                    v-if="(new Date() > new Date(type.timeStart) &&
                      (new Date() < new Date(type.timeEnd))) &&
                      type.hasMealSet && !type.isAbandoned && !type.isTaked"
                    content="Đẩy suất ăn lên chợ"
                    placement="top">
                    <button
                      @click="abandonedMealSet(type.mealSetId, type.id)"
                      style="position: absolute; top: -19px; left: -1px; border: unset;
                      border-radius: 5px; background-color: #005a88; color: #fff; cursor: pointer;">
                      <span class="el-icon-top-right"></span>
                    </button>
                  </el-tooltip>
                  <el-tooltip content="Rao bán" v-if="type.isAbandoned">
                    <span class="el-icon-refresh-right"></span>
                  </el-tooltip>
                  {{ type.label }}
                </el-checkbox-button>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Đã đăng ký" name="Đã đăng ký">
        <div style="padding: 0 10px 10px 10px;">
          <span style="margin-right: 10px; font-size: 15px;">Lọc theo ngày</span>
          <el-date-picker
            type="date"
            @change="filterCreatedMeal"
            v-model="createdDateFilter"
            format="dd-MM-yyyy"
            size="mini"
            placeholder="Chọn ngày">
          </el-date-picker>
        </div>
        <div style="max-height: 82vh; overflow: auto;">
          <div v-for="(meal, index) in created" :key="'created'+index">
            <el-divider content-position="left">
              Ngày {{ dateToStringFormat(new Date(meal[0].date)) }}
            </el-divider>
            <el-tag
              v-for="item in meal"
              :key="'item-created'+item.id"
              style="margin-right: 5px;"
              :type="getTypeOfTagByMeal(item)">
              {{ item.meal_type ? item.meal_type.name : '' }}
              <el-tooltip
                :content="`Đã ăn lúc ${getDateTimeConvert(new Date(item.meal_set.taken_at))}`"
                placement="top"
                v-if="item.meal_set.taken_at">
                <span style="color: green; cursor: pointer;" class="el-icon-success"/>
              </el-tooltip>
              <el-tooltip
                content="Đánh giá"
                placement="top"
                v-if="item.meal_set.taken_at && item.review && item.review instanceof Array">
                <el-popover
                  placement="bottom"
                  width="300"
                  v-model="item.visible"
                  :key="'rate'+item.meal_set_id"
                  trigger="manual">
                  <el-rate v-model="rate.star"></el-rate>
                  <div>
                    <el-input
                      style="margin-top: 10px;"
                      size="mini"
                      placeholder="Nhập nội dung"
                      v-model="rate.rateContent">
                    </el-input>
                  </div>
                  <div style="margin-top: 5px;">
                    <el-button
                      type="primary"
                      plain
                      v-if="!rate.file"
                      @click="$refs.rateUpload.click()"
                      style="margin-top: 10px;"
                      size="mini"
                      icon="el-icon-paperclip">
                      Đính kèm ảnh
                    </el-button>
                    <div v-show="rate.file" style="position: relative;">
                      <span class="btn-delete-image" @click="deleteRateImage">
                        Xóa ảnh
                      </span>
                      <el-image
                        style="width: 100px; height: 100px"
                        :src="previewUrlRate"
                        :preview-src-list="[previewUrlRate]">
                      </el-image>
                    </div>
                  </div>
                  <el-button
                    type="success"
                    plain
                    @click="sendReview(item.id)"
                    style="margin-top: 10px;"
                    size="mini"
                    :disabled="loadingBtnRate"
                    :icon="loadingBtnRate ? 'el-icon-loading' : 'el-icon-s-promotion'">
                    {{ loadingBtnRate ? 'Đang gửi đánh giá' : 'Gửi' }}
                  </el-button>
                  <el-button
                    type="danger"
                    plain
                    @click="item.visible = false"
                    style="margin-top: 10px;"
                    size="mini"
                    icon="el-icon-close">
                    Hủy
                  </el-button>
                  <button
                    @click="initDataRate(item)"
                    slot="reference"
                    style="color: #c9c900; cursor: pointer; border: unset; background-color: unset"
                    class="el-icon-star-off"/>
                </el-popover>
              </el-tooltip>
              <el-tooltip
                content="Xem đánh giá của bạn"
                placement="top"
                v-if="item.meal_set.taken_at
                && item.review
                && item.review instanceof Object
                && Object.keys(item.review).length">
                <el-popover
                  placement="bottom"
                  width="300"
                  trigger="click">
                  <el-rate v-model="item.review.ratings" disabled></el-rate>
                  <span style="margin-top: 10px; margin-bottom: 10px;">
                    {{ item.review.comment }}
                  </span>
                  <div v-if="item.review.img_url" style="text-align: center">
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="item.review.img_url"
                      :preview-src-list="[item.review.img_url]">
                    </el-image>
                  </div>
                  <button
                    slot="reference"
                    style="color: #c9c900; cursor: pointer; border: unset; background-color: unset"
                    class="el-icon-star-on"/>
                </el-popover>
              </el-tooltip>
              <el-tooltip
                content="Rao bán"
                v-if="!!(item.meal_set &&
                item.meal_set instanceof Object &&
                item.meal_set.abandoned_at)">
                <span class="el-icon-refresh-right"></span>
              </el-tooltip>
            </el-tag>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Đang rao bán" name="Đang rao bán">
        <div v-for="meal in mealToday" :key="'meal-today'+meal.id" style="margin-bottom: 10px;">
          <el-tag :type="getTypeOfTagByMeal(meal)">
            Bữa {{
              meal.meal_type.id === 1
                ? 'trưa' : meal.meal_type.id === 2
                  ? 'tối'
                  : meal.meal_type.id === 3
                    ? 'sáng'
                    : 'chiều'
            }}
            có {{ meal.abandoned_meal_set_count }} suất ăn.
            <el-tooltip
              v-if="meal.abandoned_meal_set_count"
              content="Lấy suất ăn lên chợ"
              placement="top">
              <button
                @click="pick(meal.id)"
                style="border: unset; background-color: #005a88; color: #fff; cursor: pointer;
                border-radius: 5px;">
                <span class="el-icon-bottom-left"></span>
              </button>
            </el-tooltip>
          </el-tag>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Thực đơn" name="Thực đơn">
        <div style="padding: 0 10px 10px 10px;">
          <span style="margin-right: 10px; font-size: 15px;">Lọc theo ngày</span>
          <el-date-picker
            v-model="menuDateFilter"
            type="date"
            @change="filterMenu"
            format="dd-MM-yyyy"
            size="mini"
            placeholder="Chọn ngày">
          </el-date-picker>
        </div>
        <div style="max-height: 82vh; overflow: auto; padding: 10px;">
          <div v-for="(meal, index) in menus" :key="'menu'+index">
            <el-divider content-position="center">
              Ngày {{ dateToStringFormat(new Date(meal[0].date)) }}
            </el-divider>
            <div v-for="item in meal" :key="'meal-for'+item.id"
                 class="menu-item"
                 :style="{border: `1px solid ${(item.meal_type ? item.meal_type.id : 0) === 3
                  ? '#ecf5ff'
                    : (item.meal_type ? item.meal_type.id : 0) === 1
                    ? '#fdf6ec'
                  : '#f0f9eb'}`}"
                 style="position: relative; padding-top: 10px;border-radius: 6px;">
              <el-tag
                style="position: absolute; top: -17px; left: 25px;"
                :type="getTypeOfTagByMeal(item)">
                {{
                  item.meal_type.id === 1
                    ? 'Bữa trưa'
                    : item.meal_type.id === 2
                      ? 'Bữa tối'
                      : item.meal_type.id === 3
                        ? 'Bữa sáng' : 'Bữa chiều'
                }}
              </el-tag>
              <div style="display: grid; grid-template-columns: auto auto auto; grid-gap: 5px;">
                <div style="grid-column: 1 / span 2;">
                  <ol>
                    <li v-for="dish in item.menu.dishes" :key="'dish'+dish.id">
                      {{ dish.name }}
                    </li>
                  </ol>
                </div>
                <div style="margin: auto;">
                  <button
                    v-if="!item.menu.img_url && permissionMenu.includes('upload')"
                    @click="uploadFile(item.menu)"
                    style="border: unset; padding: 10px 15px; border-radius: 5px; cursor: pointer;">
                    Tải ảnh suất ăn
                  </button>
                  <div v-if="item.menu.img_url" style="position: relative;">
                    <span class="btn-delete-image" @click="deleteImage(item.menu)">
                      Xóa
                    </span>
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="item.menu.img_url"
                      :preview-src-list="[item.menu.img_url]">
                    </el-image>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <label for="fileUpload" style="display: none;">
      <input
        accept=".png,.jpg,.jpeg"
        id="fileUpload" ref="fileUpload" type="file"
        @change="handleUploadFile">
    </label>
    <label for="rateUpload" style="display: none;">
      <input
        accept=".png,.jpg,.jpeg"
        id="rateUpload" ref="rateUpload" type="file"
        @change="rateUpload">
    </label>
  </div>
</template>

<script>
import Calendar from 'v-calendar/lib/components/calendar.umd';
import axios from 'axios';
import {
  Button,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Divider,
  Loading,
  Message,
  MessageBox,
  TabPane,
  Tabs,
  Tooltip,
  Tag,
  Popover,
  Rate,
  DatePicker,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Input,
  Image,
} from 'element-ui';
import lang from 'element-ui/lib/locale/lang/vi';
import locale from 'element-ui/lib/locale';

locale.use(lang);

export default {
  name: 'MealSetRegister',
  components: {
    Calendar,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip,
    [Divider.name]: Divider,
    [CheckboxGroup.name]: CheckboxGroup,
    [CheckboxButton.name]: CheckboxButton,
    [Checkbox.name]: Checkbox,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Tag.name]: Tag,
    [Popover.name]: Popover,
    [Rate.name]: Rate,
    [Input.name]: Input,
    [DatePicker.name]: DatePicker,
    [Image.name]: Image,
    Loading,
  },
  data() {
    return {
      date: new Date(),
      days: [],
      isAllLunch: false,
      isAllDinner: false,
      isAllBreakfast: false,
      isAllAffternoonSnack: false,
      btnHandling: false,
      btnCreate: false,
      loadingUpload: false,
      visibleRate: false,
      loadingBtnRate: false,
      startDate: null,
      rate: {
        rateContent: '',
        file: null,
        star: 1,
      },
      endDate: null,
      meals: [],
      idsCancel: [],
      permissionMenu: [],
      loading: null,
      tabs: ['Đã đăng ký'],
      activeName: 'Đã đăng ký',
      created: [],
      menus: [],
      createdDateFilter: '',
      menuDateFilter: '',
      previewUrlRate: '',
      mealToday: {},
      currentMenu: null,
    };
  },
  computed: {
    dates() {
      return this.days.map((day) => day.date);
    },
    attributes() {
      const attrs = this.dates.map((date) => ({
        highlight: {
          color: 'blue',
          fillMode: 'outline',
        },
        dates: date,
      }));

      const lunch = this.meals.filter(
        (meal) => (meal.meal_type ? meal.meal_type.id : 0) === 1
          && meal.meal_set
          && meal.meal_set instanceof Object
          && Object.keys(meal.meal_set).length,
      );

      const afternoonSnack = this.meals.filter(
        (meal) => (meal.meal_type ? meal.meal_type.id : 0) === 4
          && meal.meal_set
          && meal.meal_set instanceof Object
          && Object.keys(meal.meal_set).length,
      );

      const dinner = this.meals.filter(
        (meal) => (meal.meal_type ? meal.meal_type.id : 0) === 2
          && meal.meal_set
          && meal.meal_set instanceof Object
          && Object.keys(meal.meal_set).length,
      );

      const breakfast = this.meals.filter(
        (meal) => (meal.meal_type ? meal.meal_type.id : 0) === 3
          && meal.meal_set
          && meal.meal_set instanceof Object
          && Object.keys(meal.meal_set).length,
      );

      attrs.push({
        dot: 'yellow',
        dates: lunch.map((l) => new Date(l.date)),
      });

      attrs.push({
        dot: 'green',
        dates: dinner.map((d) => new Date(d.date)),
      });

      attrs.push({
        dot: 'red',
        dates: afternoonSnack.map((d) => new Date(d.date)),
      });

      attrs.push({
        dot: 'blue',
        dates: breakfast.map((b) => new Date(b.date)),
      });

      return attrs;
    },
  },
  methods: {
    initDataRate(item) {
      this.rate.rateContent = '';
      this.rate.star = 1;
      // eslint-disable-next-line no-param-reassign
      item.visible = true;
      this.rate.file = null;
    },
    deleteRateImage() {
      this.rate.file = null;
    },
    rateUpload(event) {
      // eslint-disable-next-line prefer-destructuring
      this.rate.file = event.target.files[0];
      if (this.rate.file) {
        this.previewUrlRate = URL.createObjectURL(this.rate.file);
      } else {
        this.previewUrlRate = null;
      }
    },
    async deleteImage(menu) {
      await axios.post(
        `${process.env.VUE_APP_API_URL}menus/${menu.id}/re-upload`,
      )
        .then((res) => {
          if (res.data.success) {
            menu.img_url = null;
            Message.success('Xóa ảnh thành công!');
          } else {
            Message.error(res.data.message);
          }
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            Message.error(err.response.data.message);
          } else {
            Message.error('Lỗi hệ thống!');
          }
        });
    },
    uploadFile(menu) {
      this.currentMenu = menu;
      this.$refs.fileUpload.click();
    },
    async handleUploadFile(event) {
      const loadingInstance1 = Loading.service({
        fullscreen: true,
        lock: true,
        text: 'Đang tải ảnh...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });

      const formData = new FormData();
      formData.set('file', event.target.files[0]);

      await axios.post(
        `${process.env.VUE_APP_API_URL}menus/${this.currentMenu.id}/upload`,
        formData,
      )
        .then((res) => {
          if (res.data.success) {
            this.currentMenu.img_url = res.data.data.menu.img_url;
            Message.success('Tải ảnh lên thành công!');
          } else {
            Message.error(res.data.message);
          }
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            Message.error(err.response.data.message);
          } else {
            Message.error('Lỗi hệ thống!');
          }
        });

      this.$refs.fileUpload.value = '';
      loadingInstance1.close();
    },
    getTypeOfTagByMeal(meal) {
      if ((meal.meal_type ? meal.meal_type.id : 0) === 3) {
        return 'primary';
      }

      if ((meal.meal_type ? meal.meal_type.id : 0) === 1) {
        return 'warning';
      }

      if ((meal.meal_type ? meal.meal_type.id : 0) === 2) {
        return 'success';
      }

      return 'danger';
    },
    async handleCommand(command) {
      if (command === 'logout') {
        // eslint-disable-next-line no-restricted-globals
        window.location.href = `${process.env.VUE_APP_SSO_URL}/logout?continue=${location.origin}`;
      }
      if (command === 'taken') {
        await this.taken();
      }
    },
    filterMenu() {
      this.menus = this.meals.filter(
        (m) => m.menu && m.menu instanceof Object && Object.keys(m.menu).length,
      );

      if (this.menuDateFilter instanceof Date) {
        const date = this.dateToStringFormat(this.menuDateFilter)
          .split('-')
          .reverse()
          .join('-');
        this.menus = this.menus.filter((c) => c.date === date);
      }

      this.menus = this.groupByKey(this.menus, 'date');
    },
    filterCreatedMeal() {
      this.created = this.meals.filter(
        (m) => m.meal_set && m.meal_set instanceof Object && Object.keys(m.meal_set).length,
      );
      if (this.createdDateFilter instanceof Date) {
        const date = this.dateToStringFormat(this.createdDateFilter)
          .split('-')
          .reverse()
          .join('-');
        this.created = this.created.filter((c) => c.date === date);
      }
      this.created = this.groupByKey(this.created, 'date');
    },
    abandonedMealSet(mealSetId, mealId) {
      MessageBox.confirm(
        'Do quá giờ hủy suất ăn, bạn có muốn rao bán suất ăn này không?',
        {
          confirmButtonText: 'Có',
          confirmButtonClass: 'el-button el-button--danger el-button--mini is-plain',
          cancelButtonText: 'Không',
          cancelButtonClass: 'el-button el-button--default el-button--mini',
        },
      )
        .then(async () => {
          await axios.post(
            `${process.env.VUE_APP_API_URL}meal-sets/${mealSetId}/cancel`,
          )
            .then((res) => {
              if (res.data.success) {
                Message.success('Suất ăn của bạn đang được rao bán!');
                const day = this.days.find((d) => d.data.some((m) => m.mealSetId === mealSetId));
                if (day) {
                  const data = day.data.find((o) => o.mealSetId === mealSetId);
                  if (data) {
                    data.isAbandoned = true;
                  }
                }
                const meal = this.meals.find((m) => m.id === mealId);
                if (meal) {
                  meal.abandoned_meal_set_count += 1;
                  meal.meal_set.abandoned_at = true;
                }
              } else {
                Message.error('Lỗi hệ thống!');
              }
            })
            .catch((err) => {
              if (err.response && err.response.data) {
                Message.error(err.response.data.message);
              } else {
                Message.error('Lỗi hệ thống!');
              }
            });
        })
        .catch(() => {
        });
    },
    pick(mealId) {
      MessageBox.confirm(
        'Bạn sẽ phải trả tiền cho suất ăn này, bạn có muốn lấy không?',
        {
          confirmButtonText: 'Có',
          confirmButtonClass: 'el-button el-button--danger el-button--mini is-plain',
          cancelButtonText: 'Không',
          cancelButtonClass: 'el-button el-button--default el-button--mini',
        },
      )
        .then(async () => {
          await axios.post(
            `${process.env.VUE_APP_API_URL}meals/${mealId}/pick-oldest`,
          )
            .then((res) => {
              if (res.data.success) {
                Message.success('Lấy suất ăn thành công!');
                const meal = this.mealToday.find((m) => m.id === mealId);
                if (meal) {
                  meal.abandoned_meal_set_count -= 1;
                }
                // eslint-disable-next-line no-underscore-dangle
                const _meal = this.meals.find((m) => m.id === mealId);
                if (_meal) {
                  _meal.meal_set = res.data.data.meal_set;
                }
                this.updateCreated();
              } else {
                Message.error('Lỗi hệ thống!');
              }
            })
            .catch((err) => {
              if (err.response && err.response.data) {
                Message.error(err.response.data.message);
              } else {
                Message.error('Lỗi hệ thống!');
              }
            });
        })
        .catch(() => {
        });
    },
    // eslint-disable-next-line camelcase
    async sendReview(meal_id) {
      this.loadingBtnRate = true;
      const formData = new FormData();
      formData.set('meal_id', meal_id);
      formData.set('ratings', this.rate.star);
      formData.set('comment', this.rate.rateContent);
      if (this.rate.file) {
        formData.set('file', this.rate.file);
      }

      await axios.post(
        `${process.env.VUE_APP_API_URL}reviews`,
        formData,
      )
        .then((res) => {
          if (res.data.success) {
            Message.success('Đánh giá thành công!');
            this.$refs.rateUpload.value = '';
            // eslint-disable-next-line camelcase
            const meal = this.meals.find((m) => m.id === meal_id);
            if (meal) {
              meal.review = res.data.data.review;
            }
          } else {
            Message.error(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response && err.response.data) {
            Message.error(err.response.data.message);
          } else {
            Message.error('Lỗi hệ thống!');
          }
        });
      this.loadingBtnRate = false;
    },
    getDateTimeConvert(date) {
      if (date instanceof Date) {
        return `${date.getHours()}:${date.getMinutes()} ngày ${date.getDate()
          .toString()
          .padStart(2, '0')}-${(date.getMonth() + 1).toString()
          .padStart(2, '0')}-${date.getFullYear()}`;
      }
      return '';
    },
    enableBtnCreate() {
      const days = this.days.filter((d) => d.mealSelected.length > 0);
      this.btnCreate = days.length > 0;
    },
    cancel() {
      this.btnHandling = true;
      if (this.idsCancel.length === 0) {
        Message.warning('Vui lòng chọn suất ăn cần hủy!');
        this.btnHandling = false;
        return;
      }

      MessageBox.confirm('Bạn có chắc chắn muốn hủy các suất ăn đã chọn không?', {
        confirmButtonText: 'Đồng ý',
        confirmButtonClass: 'el-button el-button--danger el-button--mini is-plain',
        cancelButtonText: 'Hủy',
        cancelButtonClass: 'el-button el-button--default el-button--mini',
      })
        .then(async () => {
          await axios.post(`${process.env.VUE_APP_API_URL}meal-sets/cancel/bulk`, {
            meal_set_id: this.idsCancel,
          })
            .then((res) => {
              if (res.data.success) {
                Message.success('Hủy suất ăn thành công!');
                this.idsCancel.forEach((id) => {
                  const day = this.days.find((d) => d.data.some((o) => o.mealSetId === id));
                  if (day) {
                    const data = day.data.find((d) => d.mealSetId === id);
                    if (data) {
                      data.mealSetId = 0;
                      data.hasMealSet = false;
                      const meal = this.meals.find((m) => m.id === data.id);
                      if (meal) {
                        meal.meal_set = [];
                      }
                      data.checkbox = false;
                    }
                  }

                  const meal = this.meals.find((m) => m.id === id);
                  if (meal) {
                    meal.meal_set = [];
                  }
                });
                this.idsCancel = [];
                this.updateCreated();
              } else {
                this.btnHandling = false;
                Message.error('Lỗi hệ thống!');
              }
            })
            .catch((err) => {
              this.btnHandling = false;
              console.log(err);
              if (err.response && err.response.data) {
                Message.error(err.response.data.message);
              } else {
                Message.error('Lỗi hệ thống!');
              }
            });
        })
        .catch(() => {
        });
      this.btnHandling = false;
    },
    cancelSelected(id) {
      // eslint-disable-next-line no-underscore-dangle
      const _idx = this.idsCancel.findIndex((i) => i === id);

      if (_idx >= 0) {
        this.idsCancel.splice(_idx, 1);
      } else {
        this.idsCancel.push(id);
      }
    },
    groupByKey(array, key) {
      return array
        .reduce((hash, obj) => {
          if (obj[key] === undefined) return hash;
          return Object.assign(hash, {
            [obj[key]]: (hash[obj[key]] || []).concat(obj),
          });
        }, {});
    },
    async save() {
      this.btnHandling = true;
      let ids = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const day of this.days) {
        ids = ids.concat(day.mealSelected);
      }

      if (ids.length === 0) {
        Message.warning('Chưa có bữa ăn nào được chọn!');
        this.btnHandling = false;
        return;
      }

      await axios.post(`${process.env.VUE_APP_API_URL}meal-sets/bulk`, {
        meal_id: ids,
      })
        .then((res) => {
          console.log('res', res);
          if (res.data.success) {
            Message.success('Đăng ký bữa ăn thành công!');
            res.data.data.meal_sets.forEach((mealSet) => {
              const day = this.days.find((d) => d.data.some((o) => o.id === mealSet.meal_id));
              if (day) {
                const data = day.data.find((d) => d.id === mealSet.meal_id);
                if (data) {
                  data.mealSetId = mealSet.id;
                  data.hasMealSet = true;
                  const meal = this.meals.find((m) => m.id === data.id);
                  if (meal) {
                    meal.meal_set = mealSet;
                  }
                }
              }

              // Cập nhật bữa ăn đã đăng ký
              const meal = this.meals.find((m) => m.id === mealSet.meal_id);
              if (meal) {
                meal.meal_set = mealSet;
              }
            });
            this.days = [];
            this.updateCreated();
          } else {
            this.btnHandling = false;
            Message.error(res.data.message);
          }
        })
        .catch((err) => {
          this.btnHandling = false;
          if (err.response && err.response.data) {
            Message.error(err.response.data.message);
          } else {
            Message.error('Lỗi hệ thống!');
          }
        });
      this.btnHandling = false;
    },
    async changeMonth(val) {
      this.loadingFunc();
      this.createdDateFilter = '';
      this.menuDateFilter = '';
      const current = new Date(val.year, val.month - 1);
      this.startDate = current;
      this.endDate = new Date(current.getFullYear(), current.getMonth() + 1, 0);

      // Lấy danh sách bữa ăn kèm các thông tin liên quan
      await this.getMeals();
      await this.updateCreated();

      // Lấy thực đơn của cả tháng
      this.menus = this.meals.filter(
        (m) => m.menu && m.menu instanceof Object && Object.keys(m.menu).length,
      );

      // Nhóm thực đơn theo ngày (bữa sáng, bữa trưa, bữa tối)
      this.menus = this.groupByKey(this.menus, 'date');

      const today = this.dateToStringFormat(new Date())
        .split('-')
        .reverse()
        .join('-');

      const mealToday = this.meals.filter((m) => m.date === today);
      if (mealToday.length > 0) {
        this.mealToday = [...mealToday];
      }
      this.loading.close();
    },
    async updateCreated() {
      this.created = this.meals.filter(
        (m) => m.meal_set && m.meal_set instanceof Object && Object.keys(m.meal_set).length,
      );
      this.created = this.groupByKey(this.created, 'date');
    },
    async getMeals() {
      const startDate = this.dateToStringFormat(this.startDate, '/');
      const endDate = this.dateToStringFormat(this.endDate, '/');
      await axios.get(`${process.env.VUE_APP_API_URL}meals?start_date=${startDate}&end_date=${endDate}&include=meal_set,menu,review&with=reviews,mealType,menu.dishes,menu&not_meal_set_user=true`)
        .then((res) => {
          if (res.data.success) {
            this.meals = [...res.data.data.meals];
          } else {
            Message.error('Không thể tải dữ liệu từ máy chủ.');
          }
        })
        .catch(() => {
          Message.error('Không thể tải dữ liệu từ máy chủ.');
        });
    },

    // Ấn vào 1 ngày
    onDayClick(day) {
      const now = new Date();
      if (day.date > now.setDate(now.getDate() - 1)) {
        const idx = this.days.findIndex((d) => d.id === day.id);
        if (idx >= 0) {
          this.days.splice(idx, 1);
        } else {
          let date = this.dateToStringFormat(day.date, '-');
          date = date.split('-')
            .reverse()
            .join('-');
          const meals = this.meals.filter((m) => m.date === date);
          let data = meals.map((m) => ({
            id: m.id, // id bữa ăn
            mealTypeId: m.meal_type ? m.meal_type.id : 0, // id loại bữa ăn
            label: m.meal_type ? m.meal_type.name : '',
            hasMealSet: m.meal_set instanceof Object && Object.keys(m.meal_set).length > 0,
            is_past: (new Date()) > (new Date(m.time_start)),
            checkbox: false,
            isAbandoned: !!(m.meal_set && m.meal_set instanceof Object && m.meal_set.abandoned_at),
            isTaked: !!(m.meal_set && m.meal_set instanceof Object && m.meal_set.taken_at),
            mealSetId: m.meal_set ? m.meal_set.id : 0,
            date: m.date,
            timeStart: m.time_start,
            timeEnd: m.time_end,
            abandoned_count: m.abandoned_meal_set_count,
          }));
          data = data.sort((a, b) => a.mealTypeId - b.mealTypeId);
          // Đẩy bữa sáng lên đầu mảng
          if (data.length === 4) {
            [data[0], data[1], data[2], data[3]] = [data[2], data[0], data[3], data[1]];
          }
          this.days.push({
            id: day.id, // id của package
            date: day.date,
            mealSelected: [],
            data,
          });
        }
      }
    },
    dateToStringFormat(date, str = '-') {
      if (date !== '' && date !== undefined && date !== null) {
        return `${date.getDate()
          .toString()
          .padStart(2, '0')}${str}${(date.getMonth() + 1).toString()
          .padStart(2, '0')}${str}${date.getFullYear()}`;
      }

      return '';
    },

    // Xử lý checkbox check all bữa trưa
    allLunch(val) {
      if (val) {
        this.days.forEach((day) => {
          day.data.forEach((d) => {
            if (d.mealTypeId === 1) {
              const index = day.mealSelected.findIndex((m) => m === d.id);
              if (!(index >= 0) && !d.mealSetId && (new Date() < new Date(d.timeStart))) {
                day.mealSelected.push(d.id);
              }
            }
          });
        });
      } else {
        this.days.forEach((day) => {
          day.data.forEach((d) => {
            if (d.mealTypeId === 1) {
              const index = day.mealSelected.findIndex((m) => m === d.id);
              if (index >= 0) {
                day.mealSelected.splice(index, 1);
              }
            }
          });
        });
      }
    },

    // Xử lý checkbox check all bữa tối
    allDinner(val) {
      if (val) {
        this.days.forEach((day) => {
          day.data.forEach((d) => {
            if (d.mealTypeId === 2) {
              const index = day.mealSelected.findIndex((m) => m === d.id);
              if (!(index >= 0) && !d.mealSetId && (new Date() < new Date(d.timeStart))) {
                day.mealSelected.push(d.id);
              }
            }
          });
        });
      } else {
        this.days.forEach((day) => {
          day.data.forEach((d) => {
            if (d.mealTypeId === 2) {
              const index = day.mealSelected.findIndex((m) => m === d.id);
              if (index >= 0) {
                day.mealSelected.splice(index, 1);
              }
            }
          });
        });
      }
    },

    // Xử lý checkbox check all bữa sáng
    allBreakfast(val) {
      if (val) {
        this.days.forEach((day) => {
          day.data.forEach((d) => {
            if (d.mealTypeId === 3) {
              const index = day.mealSelected.findIndex((m) => m === d.id);
              if (!(index >= 0) && !d.mealSetId && (new Date() < new Date(d.timeStart))) {
                day.mealSelected.push(d.id);
              }
            }
          });
        });
      } else {
        this.days.forEach((day) => {
          day.data.forEach((d) => {
            if (d.mealTypeId === 3) {
              const index = day.mealSelected.findIndex((m) => m === d.id);
              if (index >= 0) {
                day.mealSelected.splice(index, 1);
              }
            }
          });
        });
      }
    },

    // Xử lý checkbox check all bữa sáng
    allAfternoonSnack(val) {
      if (val) {
        this.days.forEach((day) => {
          day.data.forEach((d) => {
            if (d.mealTypeId === 4) {
              const index = day.mealSelected.findIndex((m) => m === d.id);
              if (!(index >= 0) && !d.mealSetId && (new Date() < new Date(d.timeStart))) {
                day.mealSelected.push(d.id);
              }
            }
          });
        });
      } else {
        this.days.forEach((day) => {
          day.data.forEach((d) => {
            if (d.mealTypeId === 4) {
              const index = day.mealSelected.findIndex((m) => m === d.id);
              if (index >= 0) {
                day.mealSelected.splice(index, 1);
              }
            }
          });
        });
      }
    },

    // Xử lý checkbox check all bữa trưa
    checkAllLunch() {
      if (this.isAllLunch) {
        let i = 0;
        this.days.forEach((day) => {
          day.data.forEach((d) => {
            if (d.mealTypeId === 1) {
              const index = day.mealSelected.findIndex((m) => m === d.id);
              if (index >= 0) {
                i += 1;
              }
            }
          });
        });
        if (i < this.days.length) {
          this.isAllLunch = false;
        }
      } else {
        let i = 0;
        this.days.forEach((day) => {
          day.data.forEach((d) => {
            if (d.mealTypeId === 1) {
              const index = day.mealSelected.findIndex((m) => m === d.id);
              if (index >= 0) {
                i += 1;
              }
            }
          });
        });
        if (i === this.days.length) {
          this.isAllLunch = true;
        }
      }
    },

    // Xử lý checkbox check all bữa tối
    checkAllDinner() {
      if (this.isAllDinner) {
        let i = 0;
        this.days.forEach((day) => {
          day.data.forEach((d) => {
            if (d.mealTypeId === 2) {
              const index = day.mealSelected.findIndex((m) => m === d.id);
              if (index >= 0) {
                i += 1;
              }
            }
          });
        });
        if (i < this.days.length) {
          this.isAllDinner = false;
        }
      } else {
        let i = 0;
        this.days.forEach((day) => {
          day.data.forEach((d) => {
            if (d.mealTypeId === 2) {
              const index = day.mealSelected.findIndex((m) => m === d.id);
              if (index >= 0) {
                i += 1;
              }
            }
          });
        });
        if (i === this.days.length) {
          this.isAllDinner = true;
        }
      }
    },

    // Xử lý checkbox check all bữa sáng
    checkAllBreakfast() {
      if (this.isAllBreakfast) {
        let i = 0;
        this.days.forEach((day) => {
          day.data.forEach((d) => {
            if (d.mealTypeId === 3) {
              const index = day.mealSelected.findIndex((m) => m === d.id);
              if (index >= 0) {
                i += 1;
              }
            }
          });
        });
        if (i < this.days.length) {
          this.isAllBreakfast = false;
        }
      } else {
        let i = 0;
        this.days.forEach((day) => {
          day.data.forEach((d) => {
            if (d.mealTypeId === 3) {
              const index = day.mealSelected.findIndex((m) => m === d.id);
              if (index >= 0) {
                i += 1;
              }
            }
          });
        });
        if (i === this.days.length) {
          this.isAllBreakfast = true;
        }
      }
    },

    // Xử lý checkbox check all bữa chiều nếu chọn thêm 1 ngày nữa thì bỏ check all
    checkAllAfternoonSnack() {
      if (this.isAllAffternoonSnack) {
        let i = 0;
        this.days.forEach((day) => {
          day.data.forEach((d) => {
            if (d.mealTypeId === 4) {
              const index = day.mealSelected.findIndex((m) => m === d.id);
              if (index >= 0) {
                i += 1;
              }
            }
          });
        });
        if (i < this.days.length) {
          this.isAllAffternoonSnack = false;
        }
      } else {
        let i = 0;
        this.days.forEach((day) => {
          day.data.forEach((d) => {
            if (d.mealTypeId === 4) {
              const index = day.mealSelected.findIndex((m) => m === d.id);
              if (index >= 0) {
                i += 1;
              }
            }
          });
        });
        if (i === this.days.length) {
          this.isAllAffternoonSnack = true;
        }
      }
    },

    // Hiển thị loading lên màn hình
    loadingFunc() {
      this.loading = Loading.service({
        fullscreen: true,
        lock: true,
        text: 'Đang tải dữ liệu...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
    },
  },
  watch: {
    days: {
      handler() {
        if (this.days.length) {
          this.activeName = 'Đã chọn';
          this.idsCancel = [];
          this.days.forEach((day) => {
            day.data.forEach((d) => {
              if (d.checkbox) {
                this.idsCancel.push(d.mealSetId);
              }
            });
          });
        } else {
          this.activeName = 'Đã đăng ký';
        }
        this.checkAllLunch();
        this.checkAllDinner();
        this.checkAllBreakfast();
        this.checkAllAfternoonSnack();
        this.enableBtnCreate();
      },
      deep: true,
    },
  },
  created() {
    axios.get(
      `${process.env.VUE_APP_API_URL}menus/permissions`,
    )
      .then((res) => {
        if (res.data.success) {
          this.permissionMenu = res.data.data.permissions;
        } else {
          console.log(res.data.message);
        }
      })
      .catch((err) => {
        console.log(err.response.data.message);
      });
  },
};
</script>

<style>
.vc-day {
  min-height: 60px !important;
}

@media (max-width: 768px) {
  .vc-day {
    min-height: 45px !important;
  }
}

.vc-day-content {
  width: 40px !important;
  height: 40px !important;
}

.vc-pane {
  box-shadow: -2px 12px 30px #939393;
  border-radius: 8px;
}

.vc-weekday, .vc-title {
  color: #005a88 !important;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #005a88;
  border-color: #005a88 !important;
}

.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #005a88;
}

.el-checkbox__input.is-focus .el-checkbox__inner, .el-checkbox__inner {
  border-color: #e6a23c;
}

.el-checkbox-button.is-disabled:first-child .el-checkbox-button__inner {
  border-left-color: #e6a23c;
}

.el-checkbox-button.is-disabled .el-checkbox-button__inner {
  color: #e6a23c;
  border: 1px solid #e6a23c;
}

.el-tabs__item {
  padding: 0 9px !important;
}

.el-checkbox__label {
  font-size: 12px !important;
}

.vc-dots {
  position: absolute !important;
  top: 44px !important;
}

@media (max-width: 768px) {
  .vc-dots {
    top: 36px !important;
  }
}
</style>

<style scoped>
.mb-3 {
  margin-bottom: 3rem;
}

.mb-1 {
  margin-bottom: 1rem;
}

.calendar {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-gap: 40px;
}

.meal {
  max-height: 75vh;
  overflow: auto;
  padding: 10px;
  margin-top: 10px;
  border: 1px solid gray;
  border-radius: 3px;
}

@media (max-width: 1035px) {
  .calendar {
    grid-template-columns: 100%;
  }

  .calendar > *:last-child {
    margin-bottom: 20px;
  }
}

.menu-item:not(:first-child) {
  margin-top: 30px;
}

.btn-delete-image {
  position: absolute;
  top: 0;
  right: 0;
  color: red;
  z-index: 1;
  background-color: #fff;
  border: 1px solid red;
  padding: 0 10px;
  cursor: pointer;
}
</style>
